import { useRef } from "react";

// svg images
import FaqBox from "./FaqBox";
import React from "react";

//styles
import variables from "../styles/utils/_variables.module.scss";
import faqs from "../assets/faq/faq.json"

interface FaqProps {
  onShowFaqSection: boolean;
  onSetShowFaqSection: () => void;
}

const Faq: React.FC<FaqProps> = ({ onShowFaqSection, onSetShowFaqSection }) => {
  const scrollIcon: any = useRef<HTMLDivElement>(null);
  const detectWasScrolled = () => {
    scrollIcon.current.style.background = variables.colorGreyDark2;
  };



  return (
    <section
      className="faq-section"
      id="faq-section"
      style={{ height: `${onShowFaqSection ? "80vh" : "0"}` }}
      onScroll={detectWasScrolled}
    >
      <div className="faq-section--scroll-icon" ref={scrollIcon}></div>
      <div className="faq-section__close-icon-holder" onClick={onSetShowFaqSection}>
        <div className="faq-section__close-icon">
          <div className="faq-section__close-icon--line"></div>
        </div>
      </div>
      <h6 className="faq-box__title">سوالات متداول</h6>
      <div className="faq-box">
        {faqs.fa.map((item, index) => {
          return <FaqBox answer={item.answer} question={item.question} key={index} />;
        })}
      </div>
    </section>
  );
};

export default Faq;
